import React from 'react';
import { CustomerOrder } from '../customerOrdersTypes';
import { OrderStatusBadge } from './OrderStatusBadge';
import styles from './OrdersTable.module.css';

interface OrdersTableProps {
  orders: CustomerOrder[];
  onViewDetails?: (orderId: string) => void;
  onReorder?: (orderId: string) => void;
  reorderingId?: string | null;
}

export const OrdersTable: React.FC<OrdersTableProps> = ({ orders, onViewDetails, onReorder, reorderingId }) => {
  if (orders.length === 0) {
    return (
      <div className={styles.card}>
        <h2 className={styles.title}>My Orders</h2>
        <div className={styles.empty}>
          <p className={styles.emptyText}>No orders found</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.card}>
      <h2 className={styles.title}>My Orders</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.th}>ORDER #</th>
              <th className={styles.th}>DATE</th>
              <th className={styles.th}>TOTAL</th>
              <th className={styles.th}>ORDER STATUS</th>
              <th className={styles.th}>PAYMENT STATUS</th>
              <th className={styles.th}>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id} className={styles.row}>
                <td className={styles.td}>
                  <span className={styles.orderNumber}>{order.orderNumber}</span>
                </td>
                <td className={styles.td}>
                  <span className={styles.date}>{order.date}</span>
                </td>
                <td className={styles.td}>
                  <span className={styles.total}>{order.total}</span>
                </td>
                <td className={styles.td}>
                  <OrderStatusBadge status={order.orderStatus} variant="order" />
                </td>
                <td className={styles.td}>
                  <OrderStatusBadge status={order.paymentStatus} variant="payment" />
                </td>
                <td className={styles.td} style={{ display: 'flex', gap: 8 }}>
                  <button
                    className={styles.viewBtn}
                    onClick={() => onViewDetails?.(order.id)}
                  >
                    View Details
                    <svg viewBox="0 0 24 24" fill="currentColor" className={styles.viewIcon}>
                      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                    </svg>
                  </button>
                  {onReorder && (
                    <button
                      className={styles.viewBtn}
                      disabled={reorderingId === order.id}
                      onClick={() => onReorder(order.id)}
                      title="Create a new order with the same items"
                    >
                      {reorderingId === order.id ? 'Reordering…' : 'Reorder'}
                      <svg viewBox="0 0 24 24" fill="currentColor" className={styles.viewIcon}>
                        <path d="M12 6V2L7 7l5 5V8c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" />
                      </svg>
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
